module.exports = __webpack_public_path__ + "static/img/arc-logo.560c2c04.svg";